import { Box } from '@chakra-ui/react';
import { FC } from 'react';

interface Props {
	colorHex: string;
	abbreviation: string;
}

const DEFAULT_SYMBOL = 'GME';

export const SymbolBox: FC<Props> = ({ colorHex, abbreviation }) => {
	return (
		<Box
			fontSize="9px"
			textTransform="uppercase"
			p="2px 6px 0px"
			bg={colorHex}
			borderRadius="2px"
		>
			{abbreviation !== '' ? abbreviation : DEFAULT_SYMBOL}
		</Box>
	);
};
